"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FermiSolution = void 0;
const GlobalEventName_1 = require("./../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
class FermiSolution {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.FERMI_SOLUTION;
        this.description = 'Decrease M€ production 1 step for each colony. Draw 1 card for each influence.';
        this.revealedDelegate = PartyName_1.PartyName.BUREAUCRATS;
        this.currentDelegate = PartyName_1.PartyName.SPOME;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const coloniesCount = player.getColoniesCount();
            player.addProduction(Resources_1.Resources.MEGACREDITS, -coloniesCount, { log: true });
            player.drawCard(turmoil.getPlayerInfluence(player));
        });
    }
}
exports.FermiSolution = FermiSolution;
//# sourceMappingURL=FermiSolution.js.map